import React from 'react';
import PropTypes from 'prop-types';

const PCDisclaimer = (props) => (
  <div className="disclaimer">
    <p>
      The statement is provided to you by NerdWallet, Inc. (&quot;Author&quot;)
      who have entered into a written referral agreement with Personal Capital
      Corporation (&quot;PCC&quot;), through which Author will be paid between
      $70 and $150 (“Referral Fee”) for each person who uses this webpage to
      register with Personal Capital and links at least $100,000 in investable
      assets to Personal Capital&apos;s Free Financial Dashboard
      (&quot;Dashboard&quot;). The Referral Fees is paid to the Author
      regardless of whether or not you become a client. Author is not affiliated
      with PCC and Author&apos;s services consist solely of referrals of
      Dashboard users and prospective clients. As a result of this arrangement
      Author may financially benefit from referring Dashboard users and
      prospective clients to Personal Capital.
    </p>
    <p>
      No fees or other amounts will be charged to Dashboard users, prospective
      clients, or clients by Author or Personal Capital as a result of the
      referral arrangement. Dashboard users and prospective clients that are
      referred to PCC and subsequently subscribe for investment advisory
      services provided by PCC&apos;s affiliated adviser, Personal Capital
      Advisors Corporation (&quot;PCAC&quot;) will not pay increased management
      fees or other similar compensation to Author, PCC or PCAC as a result of
      this arrangement.&nbsp;
      {props.advLink && (
        <span>
          Additional information about PCAC is contained in Form ADV Part 2A
          available&nbsp;
          <a href={props.advLink}>here</a>.
        </span>
      )}
    </p>
  </div>
);

PCDisclaimer.propTypes = {
  advLink: PropTypes.string,
};

PCDisclaimer.displayName = 'PCDisclaimer';

export default PCDisclaimer;
